import React, { useState, useEffect } from "react";
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar"
import Tab from '../../components/tab';
import * as CONSTANTS from '../../utils/CONSTANTS';
import { makeSideBarActive } from '../../utils/EllowUtils';
import {TabStrip } from "@progress/kendo-react-layout";
import {
  TabStripSelectEventArguments,
} from "@progress/kendo-react-layout";
import Table from "../../components/table";
import { useLocation, useNavigate } from "react-router-dom";
import CheckHistory from "../../modal/checkHistory";
import ShareLink from "../../modal/shareLink";
import { getHistory, getPayPeriod, getProjects, getTimeSheet, resendTimesheet, SentTimesheetRequest } from "./services";
import mixpanelData, { viewedpageMixpanel } from "../../utils/mixpanel";
import NotificationAlert from "../../components/notification";



function MyProfile() {
  
    const [selected, setSelected] = React.useState<number>(0);
    const value: any = useLocation().state
    const menu = makeSideBarActive(CONSTANTS.sideMenu, 1)
    const loginId = localStorage.getItem('loginId')
  const [historyModal, setHistoryModal] = useState<boolean>(false)
  const [shareLink, setShareLink] = useState<boolean>(false)
  const navigate = useNavigate()
  const [draftData, setDraftData] = useState<any>()
  const [historyData, setHistoryData] = useState<any>()
  const [projectData, setProjectData] = useState<any>()
  const [payPeriodData, setPayPeriodData] = useState<any>()
  const [checkHistoryData, setCheckHistoryData] = useState<any>()
  const canidateValues = JSON.parse(localStorage.getItem("candidateData") || "") || {}    
  const [candidateMail, setCandidateMail] = useState<any>()

  let december = 1669852800000;
  
  const [notification, setNotification] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);    
  };  
  

  useEffect(() => {
    getDraftTimeSheet('draft', '', 1, 25)
    getDraftTimeSheet('history', '', 1, 25)
    viewedpageMixpanel()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  

  const getDraftTimeSheet = (tab: string, search: string, pageNumber: number, pageSize: number) => {

    let body: any = {}
     body = {
        "candidateJobId": canidateValues && canidateValues.candidateJobId,
        "filters": { 
            "draft": tab === 'draft' ? true :  false     
        },
        "sort": {    
          "sortOrder": tab === 'draft' ? "asc" : "desc",
          "sortBy": "startDate"
        }
    }
    getTimeSheet(body, search, pageNumber, pageSize).then((response) => {
      if (response && response.status === 1) {
        switch (tab) {
          case 'draft':         
            setDraftData(response.data && response.data.filter((item: any) =>parseInt(item.startDate) >= december))
            setCandidateMail(response.data[0] && response.data[0].candidateCompanyEmail)
            return;
          case 'history':
            setHistoryData(response.data)
            setCandidateMail(response.data[0] && response.data[0].candidateCompanyEmail)
            return
        }
      }
    })
  }

  const getHistoryDetails = (timesheetId: string) => {
    getHistory(timesheetId).then((response) => {
      if (response && response.status === 1) {
        setCheckHistoryData(response.data)
      }
    })
  }

  const showHistory = (data: any) => {
    setHistoryModal(true)
    getHistoryDetails(data.timesheetId)
  }

  const createTimeSheet = () => {
    navigate('/addTimesheet', {
      state: {
        value: value && value.state
      }
    })
  }

  const shareSheetLink = (data: any) => {
    
    let body = {
      "timesheetId": data.payPeriod && data.payPeriod.id,
      "projectId": data.project && data.project.projectId,
      "userLoginId": loginId,
      "candidateEmail": data.email,
      "candidateName": canidateValues && canidateValues.candidateName,
      "jobRole": canidateValues && canidateValues.jobRole
  
    }
    SentTimesheetRequest(body).then((response) => {
      if (response && response.status === 1) {
        mixpanelData('ML- Sent Timesheet Request', {
          'source': 'Provider sent timesheet request',
          'CandidateEmail': body.candidateEmail,
          "candidateName": canidateValues && canidateValues.candidateName,
          "jobRole": canidateValues && canidateValues.jobRole,
          'distinct_id': localStorage.getItem('Email')
        })
        setShareLink(false)
      }
    })

  }

  const getProjectsWithCandidateId = (candidateId: string) => {

    getProjects(candidateId).then((response) => {
      if (response && response.status === 1) {
        setProjectData(response.data)
      }
    })
  }

  const getPayPeriodWithProjectId = (projectId: string) => {
        
    let body = {
      "projectId":projectId ,
      "candidateId": canidateValues && canidateValues.candidateId,
      "draft": "true"
    }
    getPayPeriod(body).then((response) => {
      if (response && response.status === 1) {
        let payPeriod = response.data && response.data.map((item: any) => {
          return (
            {
              id: item.timesheetId,
              name: new Date(parseInt(item.startDate)).toDateString().slice(3) + " - " + new Date(parseInt(item.endDate)).toDateString().slice(3) 
            }
          )
        })
        setPayPeriodData(payPeriod)
      }
    })
  }

  const onShareClick = () => {
    setShareLink(true)
    if (canidateValues && canidateValues.candidateId) {
      getProjectsWithCandidateId(canidateValues.candidateId)
    }
    
  }
   
  const displayNotification = (message: string) => {
    setMessage(message)
    setNotification(true)
    setTimeout(() => {
       setNotification(false)
     }, 3000);
  }

  const reSendReminder = (data: any) => {
    let body = {
      "timesheetId": data.timesheetId,
      "reportingManagerEmail": data.reportingManagerEmail,
      "submittedTo": data.submittedTo
    }
    resendTimesheet(body).then((response) => {
      if (response && response.status === 1) {
        mixpanelData('ML- Reminder sent', {
          'source': 'Provider sent reminder for approve/reject',
          "reportingManagerEmail": data.reportingManagerEmail,
          "submittedTo": data.submittedTo,
          'distinct_id': localStorage.getItem('Email')
        })
        displayNotification('Reminder sent successfully')
      }
    })
  }

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} />
      {notification && (
        <NotificationAlert onClose={() => setNotification(false)} closable={true} type={'success'} icon={true}> {message} </NotificationAlert>
      )}
      {historyModal && <CheckHistory onClose={() => setHistoryModal(false)} data={checkHistoryData} sendReminder={''} />}
      {shareLink && <ShareLink onClose={() => setShareLink(false)} clickHandler={shareSheetLink} projectData={projectData} payPeriodData={payPeriodData} getPayPeriod={getPayPeriodWithProjectId} candidateEmail={candidateMail} />}
      <div className="dashboardContent">
        <DashboardHeader 
          title={['Resources in Contract', canidateValues.candidateName]} 
          searchChange={''} 
          shareButton={true} 
          onShareClick={onShareClick} 
          createTimeSheet={createTimeSheet} 
        />
        <div className="timeSheetTab">
          <TabStrip selected={selected} onSelect={handleSelect}>
            <Tab title="Pending Timesheets">
              <div className="tableStyle no-padd-top no-min-height">
                <Table data={draftData} title="currentTimesheet" type='timeSheet'  />
              </div>
            </Tab>
            <Tab title="Submitted Timesheets">
              <div className="tableStyle no-padd-top no-min-height">
                <Table data={historyData} title="timesheetHistory" type='timeSheet'  showHistory={showHistory} sendReminder={reSendReminder}/>
              </div>
            </Tab>
          </TabStrip>
        </div>
      </div>
    </section>
  );
}
export default MyProfile
